module.exports = __webpack_public_path__ + "media/images/downwards-right-60221b09.svg";